<template>
  <div class="slide">
    <!-- 列表菜单栏选项 -->
    <van-sticky :offset-top="offsetTop">
      <van-dropdown-menu class="list">
        <van-dropdown-item :title="selectAddress" ref="items">
          <van-cascader :field-names="fieldNames" :closeable="false" v-model="cascaderValue" :options="addressOptions" @finish="onFinish" />
        </van-dropdown-item>
        <van-dropdown-item :title="priceValue" :options="priceOptions" @change="changePrice" />
        <van-dropdown-item :title="areaValue" :options="areaOptions" @change="changeArea" />
        <van-dropdown-item title="更多" ref="item">
          <div class="more_list">
            <div class="list_title">类型</div>
            <div class="list_item">
              <span :class="[siteIndex === index ? 'active' : '']" v-for="(item, index) in siteType" @click="siteIndex = index" :key="item">{{ item }}</span>
            </div>
            <div class="more_btn">
              <van-button type="default" block @click="onClose">
                取消
              </van-button>
              <van-button type="danger" block @click="onConfirm()">
                确认
              </van-button>
            </div>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </van-sticky>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
      <!-- 列表菜单栏 -->
      <div class="home_list">
        <div class="list_item" v-for="(item, index) in siteList" :key="index" @click="toSiteDetail(item.id)">
          <div class="item_content">
            <div class="content_img">
              <!-- <van-image
                height="100%"
                width="100%"
                :src=" item.videoList.length > 0 ?  item.videoList[0].thumbnailUrl : item.coverImageUrl  "
                fit="cover"
              /> -->
              <!-- <van-icon
                v-if="item.videoList.length > 0"
                name="play"
                color="#fff"
                size="15"
              /> -->
              <van-image height="100%" width="100%" :src="item.coverImageUrl" fit="cover" />
            </div>
            <div class="content_detail">
              <div class="fs16 line1 font-weightbold">
                {{ item.name }}
              </div>
              <div class="fs11 color666">
                {{ item.district }}•{{ item.address }}
              </div>
              <div class="detail_tag">
                <van-tag color="#1A85D2" plain v-for="site in item.siteCharacteristics_name" :key="site">{{ site }}</van-tag>
              </div>
              <div class="detail_number">
                <div class="number">
                  <div class="fs16 coloree0a24">{{ item.monthlyRent }}</div>
                  <div class="fs12 coloree0a24">元/月</div>
                  <div class="fs14 color000 m-l20">{{ item.area }}㎡</div>
                </div>
                <!-- <div class="fs12 color999">广告</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import {
  Button,
  Swipe,
  SwipeItem,
  Icon,
  Image,
  Search,
  DropdownMenu,
  DropdownItem,
  Tag,
  Sticky,
  Cell,
  Cascader,
  List,
} from "vant";

import storage from "@/utils/storage";
import cityData from "@/assets/js/city.js";

export default {
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Search.name]: Search,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Tag.name]: Tag,
    [Sticky.name]: Sticky,
    [Cell.name]: Cell,
    [Cascader.name]: Cascader,
    [List.name]: List,
  },
  name: "buildingList",
  props: ["offsetTop", "currentAddress", "searchValue"],
  watch: {
    searchValue: {
      immediate: true, // 这句重要
      handler(val) {
        this.params.page = 1;
        this.params.size = 10;
        this.params.keyword = val;
        //场地中心-列表
        this.siteUserH5List();
      }
    }
  },
  data() {
    return {
      params: {
        city: "",
        district: "",
        position: "",
        range_area: "",
        range_monthlyRent: "",
        renovation: "",
        keyword: "",
        page: 1,
        size: 10,
        properties: "modifytime",
        direction: "DESC",
      },
      cascaderValue: "",
      // 选项列表，children 代表子选项，支持多级嵌套
      addressOptions: [],
      fieldNames: {
        text: "name",
        value: "area_id",
        children: "child",
      },
      selectAddress: "中山市",

      priceValue: "价格",
      priceOptions: [
        { text: "价格", value: 0 },
        { text: "500以下/月", value: 1, val: "0-500" },
        { text: "500-1000元/月", value: 2, val: "500-1000" },
        { text: "1000-1500元/月", value: 3, val: "1000-1500" },
        { text: "1500-2000元/月", value: 4, val: "1500-2000" },
        { text: "2000-3000元/月", value: 5, val: "2000-3000" },
        { text: "3000-4500元/月", value: 6, val: "3000-4500" },
        { text: "4500以上/月", value: 7, val: "4500-99999" },
      ],

      areaValue: "面积",
      areaOptions: [
        { text: "面积", value: 0 },
        { text: "100平方以下", value: 1, val: "0-100" },
        { text: "100-150平方", value: 2, val: "100-150" },
        { text: "150-200平方", value: 3, val: "150-200" },
        { text: "200-300平方", value: 4, val: "200-300" },
        { text: "300-450平方", value: 5, val: "300-450" },
        { text: "450平方以上", value: 6, val: "450-99999" },
      ],
      siteList: [],

      siteType: ["不限", "精装修", "一般", "毛胚"],
      siteIndex: 0,
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
    };
  },

  //初始化加载
  created() {
    this.params.keyword = this.$props.searchValue;
    //根据当前位置获取所在市的区域地址
    this.dealCityData();
  },

  methods: {
    //上拉加载
    onLoad() {
      var that = this;
      that.params.page = !that.finished ? that.params.page+1 : that.params.page;
      setTimeout(() => {
        that.siteUserH5List();
      }, 1000);
    },

    //场地中心-列表
    siteUserH5List() {
      var that = this;
      console.log('请求前参数:',that.params)
      that.$api
        .siteUserH5ListAPI(that.params)
        .then(function(res) {
          console.log(that.siteList)
          if (res.data.code === 200) {
            res.data.dataList.forEach((element) => {
              element.siteCharacteristics_name =
                element.siteCharacteristics_name.split(",");
            });

            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page == 1) {
              that.siteList = res.data.dataList;
            } 
            if (that.params.page > 1) {
              that.siteList = [...that.siteList, ...res.data.dataList];
            }

            // 当还有数据是page++
            if (res.data.total > that.siteList.length) {
              //that.params.page = that.params.page + 1;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }
            console.log(that.siteList,that.params.page)
            that.$forceUpdate();
            // that.siteList = res.data.dataList;
          }
        })
        .catch(function(err) {
          console.log("error", err);
        });
    },

    //根据当前位置获取所在市的区域地址
    dealCityData() {
      var addressInfo = storage.getCurrentLocation();
      var provinceInfo = cityData.data.filter(
        (item) => item.name === addressInfo.address.province
      )[0];
      var cityInfo = provinceInfo.children.filter(
        (item) => item.name === addressInfo.address.city
      );
      console.log(addressInfo.address.province, addressInfo.address.city)
      var districtInfo = cityInfo[0].children;
      this.selectAddress = addressInfo.selectAddress;
      this.params.city = addressInfo.selectAddress;
      this.addressOptions = districtInfo;
      if (this.addressOptions[0].name != addressInfo.selectAddress) {
        districtInfo.unshift({
          name: addressInfo.selectAddress,
          area_id: cityInfo[0].city_id,
        });
      }

      //场地中心-列表
      this.siteUserH5List();
    },

    //选择价格
    changePrice(i) {
      this.priceValue = this.priceOptions[i].text;
      if (this.priceOptions[i].value != 0) {
        this.params.range_monthlyRent = this.priceOptions[i].val;
      } else {
        this.params.range_monthlyRent = "";
      }
      this.params.page = 1;
      //场地中心-列表
      this.siteUserH5List();
    },

    //选择面积
    changeArea(i) {
      this.areaValue = this.areaOptions[i].text;
      if (this.areaOptions[i].value != 0) {
        this.params.range_area = this.areaOptions[i].val;
      } else {
        this.params.range_area = "";
      }
      this.params.page = 1;
      //场地中心-列表
      this.siteUserH5List();
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.selectAddress = selectedOptions[0].name;
      this.params.district = selectedOptions[0].name != "中山市" ? selectedOptions[0].name : '';
      this.showCascader = false;
      this.$refs.items.toggle();
      this.params.page = 1;
      //场地中心-列表
      this.siteUserH5List();
    },

    toSiteDetail(id) {
      this.$router.push({ path: "/home/siteDetail", query: { id: id } });
    },

    onClose() {
      this.params.renovation = "";
      this.siteIndex = 0;
      this.$refs.item.toggle();
      //场地中心-列表
      this.siteUserH5List();
    },

    onConfirm() {
      this.params.page = 1;
      this.params.renovation = this.siteIndex === 0 ? "" : this.siteIndex;
      this.$refs.item.toggle();
      //场地中心-列表
      this.siteUserH5List();
    },
  },
};

</script>
<style lang="less" scoped>
.more_list {
  display: flex;
  flex-direction: column;
  padding: 10px 20px;

  .list_title {
    font-size: 13px;
    margin-bottom: 10px;
  }

  .list_item {
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;

    >span {
      background: #f3f3f3;
      border-radius: 1000px;
      padding: 5px 20px;
      margin-right: 5px;
    }

    .active {
      background: #ee0a24;
      color: #fff;
    }
  }

  .more_btn {
    display: flex;
    margin-top: 30px;

    .van-button {
      padding: 0px !important;
      height: 35px;
      font-size: 13px;
    }
  }
}

// 列表菜单栏
.home_list {
  display: flex;
  flex-direction: column;

  .list_item {
    display: flex;
    flex-direction: column;
    padding: 0px 10px;

    .item_content {
      display: flex;
      flex-direction: row;
      padding: 20px 0px;
      border-bottom: 1px solid #f1f1f1;

      .content_img {
        position: relative;
        width: 130px;
        height: 90px;
        border-radius: 2px;
        overflow: hidden;

        .van-icon {
          position: absolute;
          bottom: 10px;
          right: 10px;
          background: rgba(0, 0, 0, 0.5);
          padding: 5px;
          border-radius: 100%;
        }
      }

      .content_detail {
        width: 60%;
        display: flex;
        flex-flow: column; //垂直排列
        justify-content: space-between; //两端对齐
        margin-left: 15px;

        /deep/ .detail_tag {
          display: flex;
          flex-wrap: wrap;

          .van-tag--plain {
            margin-top: 5px;
            padding: 2px 3px;
            margin-right: 5px;
          }
        }

        .detail_number {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
          align-items: flex-end;

          .number {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
          }
        }
      }
    }
  }
}

.slide /deep/ .van-cascader__header {
  height: 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/home/components/BuildingList.vue